import { IRatingScaleProps } from './IRatingScaleProps';
import { IOption } from '@srm/ui/types/IOption';
import { RatingScaleSelect } from './RatingScaleSelect';

const scaleOptions: IOption[] = [
    { value: 5.0, label: '5' },
    { value: 2.0, label: '2' },
];

/** ТМЦ-работы-услуги (5,2) */
export const RatingScaleTMC = (props: IRatingScaleProps) => (
    <RatingScaleSelect {...props} scaleClassName="offer-crit-rating-scale-tmc" options={scaleOptions} />
);
